const key = "fake-businesses";

const applicable = (resp) => {
	// api/forms/${formId}/entities/${entityId}/businesses
	return (resp.config.method === "GET" || resp.config.method === "POST") && resp.config.url.match(/api\/forms\/[0-9]*\/entities\/[0-9]*\/businesses$/);
};

const modify = (resp) => {
	if(resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;
	
	if(resp.config.method === "GET") {

		resp.data.Data = [
			{
				IsValid: true,
				Profile: {
					Id: 1101,
					Code: "c0508cc0-b53f-4366-afe1-dc22aaee90b1",
					Name: "TEST GSAD Dealer",
					PhoneNumbers: [
						{
							Value: "+1 2253417622",
							Type: {
								Code: "PRIMARY"
							}
						}
					],
					Addresses: [
						{
							AddressLine1: "18476 Lake Camellia Ave",
							Locale: "Baton Rouge",
							Territory: "LA",
							PostalCode: "70817",
							Country: "USA",
							Type: {
								Code: "PHYSICAL"
							}
						}
					]
				}
			},
			{
				IsValid: false,
				Profile: {
					Id: 1103,
					Code: "3096e22c-2d97-423d-b356-d03786c63d42",
					Name: "BBB-TEST GSAD Dealer",
					PhoneNumbers: [
						{
							Value: "+1 2253123452",
							Type: {
								Code: "PRIMARY"
							}
						}
					],
					Addresses: [
						{
							AddressLine1: "18476 Lake Camellia Ave",
							Locale: "Baton Rouge",
							Territory: "LA",
							PostalCode: "70817",
							Country: "USA",
							Type: {
								Code: "PHYSICAL"
							}
						}
					]
				}
			}
		];
	}

	if(resp.config.method === "POST") {
		resp.data.Data = {
			...resp.config?.data,
			Id: 1103,
			Code: "cad4958d-6d80-4b56-bc67-84e8c6a3154e"
		};
	}

	return resp;
};

export const fakeBusinesses = [key, applicable, modify];